import { hasUserPolicyStoreExpired, initializeOcpsPolicyStore } from 'owa-ocps-get-policies';
import type { OcpsPolicyStore, UserOcpsPolicies } from 'owa-ocps-get-policies';
import { USER_OCPS_POLICY_STORE } from 'owa-ocps-get-policies/lib/utils/constants';
import { OcpsPolicy } from './OcpsPolicy';
import { getItem, itemExists, localStorageExists } from 'owa-local-storage';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function getOcpsPolicyFromLocalStore(
    mailboxInfo: MailboxInfo,
    policyName: OcpsPolicy
): string | undefined {
    if (localStorageExists(window) && itemExists(window, USER_OCPS_POLICY_STORE)) {
        const ocpsPolicyStore: OcpsPolicyStore = JSON.parse(
            getItem(window, USER_OCPS_POLICY_STORE) ?? 'null'
        );
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);

        const PolicyToStoreMap: Record<OcpsPolicy, keyof UserOcpsPolicies> = {
            [OcpsPolicy.Feedback]: 'feedbackEnabled',
            [OcpsPolicy.Contact]: 'emailCollectionEnabled',
            [OcpsPolicy.NpsSurvey]: 'npsSurveyEnabled',
            [OcpsPolicy.ScreenShot]: 'screenshotEnabled',
            [OcpsPolicy.Content]: 'logContentEnabled',
            [OcpsPolicy.OutlookRecommendation]: 'outlookRecommendationEnabled',
            [OcpsPolicy.ContactSupport]: 'contactSupportEnabled',
            [OcpsPolicy.GetDiagnostics]: 'getDiagnosticsEnabled',
            [OcpsPolicy.DiagnosticsTroubleshooting]: 'diagnosticsTroubleshootingEnabled',
            [OcpsPolicy.OptionalConnectedExperiences]: 'optionalConnectedExperiencesEnabled',
            [OcpsPolicy.ConnectedOfficeExperience]: 'connectedOfficeExperiencesEnabled',
            [OcpsPolicy.CopilotBlockAccessToOpenFiles]: 'copilotBlockAccessToOpenFilesEnabled',
            [OcpsPolicy.CopilotChatSidepane]: 'copilotChatSidepaneEnabled',
            [OcpsPolicy.Loop]: 'loopEnabled',
            [OcpsPolicy.LoopEnabledForOutlook]: 'loopEnabledForOutlook',
            [OcpsPolicy.DisableSharingPermissions]: 'disableSharingPermissions',
            [OcpsPolicy.ExperiencesAnalyzingContent]: 'experiencesAnalyzingContentEnabled',
            [OcpsPolicy.ExperiencesDownloadingContent]: 'experiencesDownloadingContentEnabled',
            [OcpsPolicy.EmailCollectionDefault]: 'emailCollectionDefault',
            [OcpsPolicy.ScreenShotDefault]: 'screenshotDefault',
            [OcpsPolicy.ContentSamplesDefault]: 'contentSamplesDefault',
            [OcpsPolicy.M365LinksHandlingBrowserChoice]: 'M365LinksHandlingBrowserChoice',
            [OcpsPolicy.LoopPolls]: 'loopPollsEnabled',
            [OcpsPolicy.ShowCardLoops]: 'showCardLoops',
            [OcpsPolicy.LoopPlanner]: 'loopPlannerEnabled',
            [OcpsPolicy.LoopVideoPlayback]: 'loopVideoPlaybackEnabled',
            [OcpsPolicy.LoopVideoRecord]: 'loopVideoRecordEnabled',
            [OcpsPolicy.CopilotComplianceGuidance]: 'copilotComplianceGuidance',
        };

        if (ocpsPolicyStore && ocpsPolicyStore.policies[accountKey]) {
            const userPolicies: UserOcpsPolicies = ocpsPolicyStore.policies[accountKey];

            // Re-initialize the policy store if policy store has expired
            if (
                isGlobalFeatureEnabled('ocps-expired-store-refresh') &&
                hasUserPolicyStoreExpired(userPolicies.expirationDate)
            ) {
                initializeOcpsPolicyStore('expiredStoreRefresh');
            }
            const storePolicyValue: keyof UserOcpsPolicies = PolicyToStoreMap[policyName];

            return userPolicies[storePolicyValue];
        }
    }
    return undefined;
}
